import React, { FC } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { logger } from '@fiverr-private/obs';
import { Author as AuthorType } from '../../../../../../shared/types';
import { Author } from '../../../../shared/Author';

export const AboutAuthor: FC<AuthorType> = (props) => {
  const { photo, authorName, heading } = props;

  if (!photo) {
    logger.error(`Author photo is missing for ${authorName}`, { ...props });
  }

  return <Author {...props} heading={heading || translate<string>('fiverr_guides.guide.author.heading')} />;
};
